import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import Input from '../component/Input.js';
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';
import Validation from './Validation.js'; //used for validation
import SelectBox from '../component/Select.js';

export default class CreateAdminMessages extends Component {
	constructor(props){
		super(props);
		this.handleInput = this.handleInput.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.handleStart = this.handleStart.bind(this);
		this.handleEnd = this.handleEnd.bind(this);
		this.getDays = this.getDays.bind(this);
		this.createDateObject = this.createDateObject.bind(this);
		this.isLeapYear = this.isLeapYear.bind(this);
		this.state = {message:'',startDate:{month:'',day:'',year:'',monthDays:[]},endDate:{month:'',day:'',year:'',monthDays:[]},modalIsOpen:false,modalPrompt:'',today:''};
	}

	isLeapYear(year){ //method for determining whether or not a year is a leap year
		 return (year % 100 === 0) ? (year % 400 === 0) : (year % 4 === 0);
	}

	componentDidMount(){ //when component mounts get today's date from the server
		axios({
			method:'post',
			url:path,
			headers:{'Content-Type':'application/json'},
			data:{"endpoint":"getDate"}
		}).then((response)=>{
			let today = response.data.data;
			let defaultStart = today.split("/");
			let monthDays = this.getDays(defaultStart[0]);
			let endDay = (Number(defaultStart[1]) + 1).toString();
			this.setState({today:today,startDate:{month:defaultStart[0],day:defaultStart[1],year:defaultStart[2],monthDays:monthDays},endDate:{month:defaultStart[0],day:endDay,year:defaultStart[2],monthDays:monthDays}});
		});
	}

	getDays(value,year){ //method for determing how many days in each month
		let days;
		if(value === '02'){
			days = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28'];
			if(this.isLeapYear(year)){
				days.push('29');
			}
		}else if(value === '01' || value === '03' || value === '05' || value === '07' || value === '08' || value === '10' || value === '12'){
			days = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'];
		}else{
			days = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'];
		}
		return days;
	}

	createDateObject(dateString){ //method to create date objects out of the selected dates in order to perform further validation using date comparisons
		let year = dateString.substr(6);
		let day = dateString.substr(3,2);
		let month = Number(dateString.substr(0,2));
		month = (month-1).toString();
		let d = new Date(year,month,day);
		return d;
	}

	openModal(){ //method to open the modal
		this.setState({modalIsOpen:true});
	}

	closeModal(){ //method to close the modal
		this.setState({modalIsOpen:false,modalPrompt:''});
		this.props.revertSave();
	}

	handleStart(identity,value){ //method for handling the change of the start date dropdown menus
		const theState = this.state.startDate;
		theState[identity] = value;
		if(identity === "month"){
			let year = theState['year'];
			theState['monthDays'] = this.getDays(value,year);
			theState['day'] = '01';
		}else if(identity === "year"){
			theState['monthDays'] = this.getDays(theState['month'],value);
			theState['day'] = '01';
		}
		this.setState({startDate:theState});
	}

	handleEnd(identity,value){ //method for handling the change of the end date dropdown menus
		const theState = this.state.endDate;
		theState[identity] = value;
		if(identity === "month"){
			let year = theState['year'];
			theState['monthDays'] = this.getDays(value,year);
			theState['day'] = '01';
		}else if(identity === "year"){
			theState['monthDays'] = this.getDays(theState['month'],value);
			theState['day'] = '01';
		}
		this.setState({endDate:theState});
	}

	handleInput(identity,value){ //standard method for updating the state based on user input from select menus
		if(value.length < 186){
			const theState = {};
			theState[identity] = value;
			this.setState(theState);
			document.getElementById("messageSpan").style.color = "#001B44";
			document.getElementById("messageSpan").innerHTML = "("+value.length+")";
		}else{
			document.getElementById("messageSpan").style.color = "red";
			document.getElementById("messageSpan").innerHTML = "(185) Limit Reached!";
		}
	}

	componentDidUpdate(prevProps){
		const {message,startDate,endDate} = this.state;
		if(prevProps.save !== this.props.save && this.props.save){ //if the user has chosen to save the new admin message
			document.getElementById("message").classList.remove("invalid");
			let theStart = startDate.month +"/"+startDate.day+"/"+startDate.year;
			let theEnd = endDate.month+"/"+endDate.day+"/"+endDate.year;
			let start = this.createDateObject(theStart);
			let end = this.createDateObject(theEnd);
			let today = this.createDateObject(this.state.today);
			if(message.trim() !== '' && Validation("reason",message) && start >= today && end > start){ //validate the message, start date and end date of message
				
				axios({ //send info to create new admin message in database
					method:'post',
					url:path,headers:{'Content-Type':'application/json'},
					data:{"endpoint":"create","table":"messages","misc":"new","firstID":this.props.userInfo.userID,"status":this.props.userInfo.userType,"desc":message.trim(),"date":theStart,"secondDate":theEnd}
				}).then((response)=>{
					let data = response.data.data;
					if(data.Message === "Success!"){
						this.setState({message:'',modalPrompt:'Message successfully created!'},function(){
							this.openModal();
							this.props.reset(this.props.year);
						});
					}
				}).catch((error)=>{
					this.setState({modalPrompt:"Sorry, there has been a problem."},function(){
						this.openModal();
					});
				});
				
			}else{ //if validation was not passed for any of the fields
				let prompt = '';
				if(message.trim() === '' || !Validation("reason",message)){ //invalid input field for message
					document.getElementById("message").classList.add("invalid");
					if(message.trim() === ''){
						prompt += "Message cannot be blank. ";
					}else{
						prompt += "Message input contains invalid characters. ";
					}
				}
				if(start < today){ //invalid start date
					prompt += 'Your start date must be today or a later date. ';
				}
				if(end <= start){ //invalid end date
					prompt += 'Your end date must be after your start date. ';
				}
				prompt += 'Please try again.';
				this.setState({modalPrompt:prompt},function(){
					this.openModal();
				});
			}
		}
	}

	render(){
		let startDate = this.state.startDate;
		let endDate = this.state.endDate;
		let startMonth = startDate.month;
		let endMonth = this.state.endDate.month;
		const selectStyles = "h2 pa1 w-100 br2 bw1 truncate shadow-2";
		let months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
		let startdays = startDate.monthDays;
		let endDays = endDate.monthDays;
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    minHeight:'160px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '300px 160px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)',
			}
		};

		let inputStyles = "h2 pa2 br2 bw1 w-100-ns w-100 shadow-2";
		let areaStyles = "pa2 br2 bw1 w-100-ns w-100 shadow-2";
		if(this.state.modalPrompt === 'Your input is invalid. Please try again.'){
			areaStyles = "pa2 br2 b--red bw1 w-100-ns w-100 shadow-2";
		}else if(this.state.modalPrompt === 'Your dates are invalid. Please try again.'){
			inputStyles = "h2 pa2 br2 b--red bw1 w-100-ns w-100 shadow-2";
		}
		let modalContent = <p className="f4 b navy tc">{this.state.modalPrompt}</p>;
		return(
			<div style={{maxWidth:'500px',margin:'auto'}} className="w-80">
				<div>
					<div className="fl w-100 mt3 pb4 bb b--light-silver">
						<div className="fl w-100 pb3 tc">
							<label className="b navy f4">Start Date</label>
						</div>
						<div className="fl w-100">
							<div className="fl w-33">
								<div className="fl w-100 pb1">
									<label className="b navy">Month:</label>
								</div>
								<div className="fl w-100 pr2">
									<SelectBox identity="month" options={months} onSelect={this.handleStart} styles={selectStyles} val={startDate.month}/>
								</div>
							</div>
							<div className="fl w-33">
								<div className="fl w-100 pb1">
									<label className="b navy">Day:</label>
								</div>
								<div className="fl w-100 pr2">
									<SelectBox identity="day" options={startdays} onSelect={this.handleStart} styles={selectStyles} val={startDate.day}/>
								</div>
							</div>
							<div className="fl w-33">
								<div className="fl w-100 pb1">
									<label className="b navy">Year:</label>
								</div>
								<div className="fl w-100 pr2">
									<SelectBox identity="year" options={this.props.years} onSelect={this.handleStart} styles={selectStyles} val={startDate.year}/>
								</div>
							</div>
						</div>
					</div>
					<div className="fl w-100 mt3 pb3">
						<div className="fl w-100 pb3 tc">
							<label className="b navy f4">End Date </label>
						</div>
						<div className="fl w-100">
							<div className="fl w-33">
								<div className="fl w-100 pb1">
									<label className="b navy">Month:</label>
								</div>
								<div className="fl w-100 pr2">
									<SelectBox identity="month" options={months} onSelect={this.handleEnd} styles={selectStyles} val={this.state.endDate.month}/>
								</div>
							</div>
							<div className="fl w-33">
								<div className="fl w-100 pb1">
									<label className="b navy">Day:</label>
								</div>
								<div className="fl w-100 pr2">
									<SelectBox identity="day" options={endDays} onSelect={this.handleEnd} styles={selectStyles} val={this.state.endDate.day}/>
								</div>
							</div>
							<div className="fl w-33">
								<div className="fl w-100 pb1">
									<label className="b navy">Year:</label>
								</div>
								<div className="fl w-100 pr2">
									<SelectBox identity="year" options={this.props.years} onSelect={this.handleEnd} styles={selectStyles} val={this.state.endDate.year}/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="fl w-100 mt3 pr3">
					<div className="fl w-100 pb1">
						<label className="b navy">Message: <span id="messageSpan"></span></label>
					</div>
					<div className="fl w-100">
						<Input type="text" identity="message" id="message" onInput={this.handleInput} val={this.state.message} inputStyle={inputStyles}/>
					</div>
				</div>
				<div>
					<Modal
		          isOpen={this.state.modalIsOpen}
		          style={customStyles}
		          contentLabel="prompt"
		          shouldCloseOnOverlayClick={false}
		          shouldCloseOnEsc={false}
		        >
		        <div className="fl w-100 tr">
		        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
		        </div>
		        <div className="pt2">
		        	{modalContent}
		        </div>
		        </Modal>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/CreateAdminMessages.js